import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import ChevronRight from '@/assets/icons/chevron-right.svg';
import Close from '@/assets/icons/close.svg';
import Exit from '@/assets/icons/exit.svg';
import Warning from '@/assets/icons/warning.svg';
import { getFullName } from '@proprioo/hokkaido';
import { Button, ButtonAppearance, IconPosition } from '@proprioo/salatim';

import {
  ButtonsWrapper,
  ExistingCustomer,
  ExistingMessage,
  WarningWrapper
} from './ExistingCustomerWarning.styles';
import { ExistingCustomerProps } from './interfaces';

const ExistingCustomerWarning: FC<
  Omit<ExistingCustomerProps, 'redirectToCustomer' | 'customer'>
> = ({
  fetchedCustomer,
  mergeCustomerButtonLabel = 'linkProjectToAccount',
  onCancel,
  onSelect
}) => {
  const { t } = useTranslation();

  const openCustomer = () => {
    window.open(`/customer/${fetchedCustomer?.user.id}`, '_blank');
  };

  return (
    <ExistingCustomer>
      <WarningWrapper>
        <Warning aria-label={t('warning')} />
      </WarningWrapper>
      {fetchedCustomer && (
        <ExistingMessage
          data-test="existing-customer-text"
          dangerouslySetInnerHTML={{
            __html: t('existingEmailError', {
              fullName: getFullName(
                fetchedCustomer.user.firstName,
                fetchedCustomer.user.lastName
              ),
              nbBuy: t('buyerProjectsCount', {
                count: fetchedCustomer.countAlerts
              }),
              nbSell: t('sellerProjectCount', {
                count: fetchedCustomer.countOpportunities
              })
            })
          }}
        />
      )}
      <ButtonsWrapper>
        <Button
          data-test="existing-customer-back"
          label={t('cancel')}
          appearance={ButtonAppearance.SECONDARY}
          iconPosition={IconPosition.LEFT}
          icon={<Close />}
          onClick={() => onCancel()}
        />
        <Button
          data-test="see-customer-profile"
          label={t('seeAccount')}
          appearance={ButtonAppearance.SECONDARY}
          iconPosition={IconPosition.LEFT}
          icon={<Exit />}
          onClick={openCustomer}
        />
        <Button
          data-test="existing-customer-button"
          label={t(mergeCustomerButtonLabel)}
          icon={<ChevronRight />}
          onClick={onSelect}
        />
      </ButtonsWrapper>
    </ExistingCustomer>
  );
};

export default ExistingCustomerWarning;
